import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

/**
 * Функция удаления связи
 */
export const useRemoveObjectTepesEdges = () => {
  const http = useHttp()

  const { addError } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.del(`/types/${data.from_type_id}/links/${data.id}`)
    },
  })

  const remove = async (data: any) => {
    try {
      await mutation.mutateAsync(data)
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    remove,
  }
}
